import { useContext } from 'react';
import MediaDeviceContext from '../MediaDevices';

export default () => {
  const MediaDevice = useContext(MediaDeviceContext);

  return MediaDevice;
};
